import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';
import { sha256 } from 'js-sha256';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        let methodDetails = {
            method: 'CheckTicketLoggedOut',
        };

        // If we are logged in, add the headers
        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            methodDetails = {
                method: 'CheckTicketLoggedIn',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
            };
        }

        let a = payload.ticket1_1_1 || '';
        let b = payload.ticket1_1_2 || '';
        let c = payload.ticket1_1_3 || '';
        let d = payload.ticket1_1_4 || '';
        let e = payload.ticket1_1_5 || '';

        payload.ticket_number = a + b + c + d + e;

        // If we are logged out, add the add hash to args
        if (!jwtFromCookie || !sharedCookie) {
            payload.hash = sha256(payload.ticket_number + '.' + payload.device_id + '.' + payload.salt);
        }
        let checkResult = await apiClient(config).apiMethod({
            ...methodDetails,
            args: {
                ...payload,
            },
        });
        if (!checkResult) {
            return {
                success: false,
                message: '_UNKNOWN',
            };
        }
        if (checkResult.code) {
            if (checkResult.code === '_SUCCESS') {
                return {
                    entry: checkResult,
                    success: true,
                    message: 'success',
                };
            }
            return {
                success: false,
                message: checkResult.message ? checkResult.message : checkResult.code,
            };
        }
        return {
            entry: checkResult,
            success: true,
            message: 'success',
        };
    };
};
